import { gql } from "@apollo/client";

export const GET_ROIS = gql`
  query GetROIs($query: QueryInput, $roi: ROIInput) {
    rois(query: $query, roi: $roi) {
      rois {
        _id
        employee {
          id
          name
        }
        asset {
          id
          make
          model
          serial
          type
        }
        qa_date
        customer {
          id
          name
          business_name
        }
        invoice {
          id
          number
          total
          cogs
          net_revenue
        }
        line_items {
          item
          product_id
        }
        warranty_total
        discount_total
        ticket {
          id
          number
        }
      }
      metaData {
        totalCount
        totalPages
        limit
      }
    }
  }
`;
